<template>

    <router-view></router-view>
</template>

<script>
export default {

}
</script>
<style>
body{
	background:#f1f1f1;
}
/*  #ifdef  H5  */
body {
	max-width: 450px !important;
	margin: auto !important;
}
/*  #endif  */
</style>
